
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93lfNmCyMKUOMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_936S0S16LYz3Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/blogg/[...slug].vue?macro=true";
import { default as indexSm2O4xyDWUMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/blogg/index.vue?macro=true";
import { default as index8ppu1wn9bxMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/checkout/index.vue?macro=true";
import { default as paymentvU3cXUA3ZXMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clientMif80TzmmFMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexivu0t9XHY8Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/collections/index.vue?macro=true";
import { default as _91slug_93Q5hAAJIMkAMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/faq/[slug].vue?macro=true";
import { default as indexHfbjK1SgXxMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexuTnhBPskE4Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/index.vue?macro=true";
import { default as indexo1yw4eBzCsMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/login/index.vue?macro=true";
import { default as _91id_93qxkx0Ktik4Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/qr-pr/[id].vue?macro=true";
import { default as formipen8mGrZDMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/review/form.vue?macro=true";
import { default as indexwSc33xAZppMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_93SmuqFjD1idMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/shop/[...slug].vue?macro=true";
import { default as indexg17it2xgyiMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___no",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93lfNmCyMKUOMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___no",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___no",
    path: "/blogg",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___no",
    path: "/checkout",
    meta: index8ppu1wn9bxMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___no",
    path: "/checkout/payment",
    meta: paymentvU3cXUA3ZXMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___no",
    path: "/checkout/thank-you",
    meta: index_46clientMif80TzmmFMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___no",
    path: "/kolleksjoner",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___no",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___no",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___no",
    path: "/",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/index.vue")
  },
  {
    name: "login___no",
    path: "/login",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___no",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___no",
    path: "/review/form",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/review/form.vue")
  },
  {
    name: "review___no",
    path: "/review",
    meta: indexwSc33xAZppMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___no",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___no",
    path: "/track",
    meta: indexg17it2xgyiMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/pages/track/index.vue")
  }
]